import PropTypes from "prop-types"
import React from "react"
import {Icon} from "semantic-ui-react"
import {useSheet} from "../SheetProvider/sheetProvider"
import "./menuItem.scss"

/**
 * Item in a menu.
 */
const MenuItem = ({onClick, isHovering, active, onMouseEnter, onMouseLeave, children, displayNotification, dataTestId}) => {
    const sheet = useSheet()
    return (
    // Text color is secondary color when hovering, tertiary color otherwise.
    // When item is active, color stay to secondary color.
    <div
        className={
            (isHovering || active ? sheet.classes.textSecondaryColor : sheet.classes.textTertiaryColor) +
            " menu-item font-bold"
        }
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        data-testid={dataTestId}
    >
        {displayNotification && <Icon className={sheet.classes.textDangerColor} name="bell" />}
        {children}
    </div>
    )
}

MenuItem.propTypes = {
    onClick: PropTypes.func,
    active: PropTypes.bool,
    displayNotification: PropTypes.bool,
    isHovering: PropTypes.bool.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    dataTestId: PropTypes.string,
}

export default MenuItem
